import { render, staticRenderFns } from "./KycCompanyInfo.vue?vue&type=template&id=b954f51a&scoped=true"
import script from "./KycCompanyInfo.vue?vue&type=script&lang=js"
export * from "./KycCompanyInfo.vue?vue&type=script&lang=js"
import style0 from "./KycCompanyInfo.vue?vue&type=style&index=0&id=b954f51a&lang=scss&scoped=true"
import style1 from "./KycCompanyInfo.vue?vue&type=style&index=1&id=b954f51a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b954f51a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b954f51a')) {
      api.createRecord('b954f51a', component.options)
    } else {
      api.reload('b954f51a', component.options)
    }
    module.hot.accept("./KycCompanyInfo.vue?vue&type=template&id=b954f51a&scoped=true", function () {
      api.rerender('b954f51a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/kyc/KycCompanyInfo.vue"
export default component.exports